import React, { useMemo } from 'react';
import { useAuth } from '../hook/useAuth';
import ForbiddenPage from '../pages/forbidden/ForbiddenPage';

const RequirePermission = ({ permissions, accessLevels = [], children, fallback = <ForbiddenPage /> }) => {
    const { isUserInAnyRole, getAccessLevel } = useAuth();
    const accessLevel = useMemo(() => getAccessLevel(), [getAccessLevel]);
    if (isUserInAnyRole(permissions) && accessLevels.includes(accessLevel)) {
        return children;
    }
    return fallback;
};

export default RequirePermission; 